export default {
  contentfulHost: process.env.VUE_APP_CONTENTFUL_HOST,
  contentfulAccessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN,
  contentfulSpaceId: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
  appEnvironment: process.env.VUE_APP_ENVIRONMENT,
  apiEndpoint: process.env.VUE_APP_API_ENDPOINT,
}
